export function dito() {
  // AOS.init({
  //   offset: 200,
  //   duration: 800,
  //   delay: 200,
  // });



  $('.milestone-slider').slick({
    slidesToShow: 5.5,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    infinite: false,
    adaptiveHeight: true,
    prevArrow: $(".mile-prev"),
    nextArrow: $(".mile-next"),
    responsive: [{
      breakpoint: 1025,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1
      }
    },{
      breakpoint: 769,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },{
      breakpoint: 768,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        centerMode: false
      }
    }]
  });

  $('#kami-slider').slick({
    slidesToShow: 1.65,
    slidesToScroll: 1,
    //  asNavFor: '.slider-for',
    dots: true,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true
      }
    }]
  });

  $('.faq-slider').slick({
    slidesToShow: 1.65,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    centerMode: true,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: false,
        centerMode: false
      }
    }]
  });

  $('.news-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 1,
    //  asNavFor: '.slider-for',
    dots: false,
    arrows: true,
    centerMode: true,
    focusOnSelect: false,
    prevArrow: $(".prev-news"),
    nextArrow: $(".next-news"),
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true
      }
    },{
      breakpoint: 769,
      settings: {
        slidesToShow: 1.8,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true
      }
    },{
      breakpoint: 1200,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true
      }
    }]
  });


  $(document).ready(function() {
    $(".consent-bar .action").click(function(){
      $.cookie('beta_consent', true);
      $(".consent-bar").fadeOut(100);
      $('body,.nav-header').removeAttr('style');
    });

//            if(!$.cookie('beta_consent')){
//                debugger;
//                $(".consent-bar").show();
    //               setTimeout(function(){
    //                   $('body,.nav-header').css("margin-top",document.querySelector(".consent-bar").offsetHeight+"px");
    //               },100)
    //           }

    $(".preloader").fadeOut(100);
    var highestBox = 0;
    $('.mile-snip', this).each(function(){
      if($(this).height() > highestBox) {
        highestBox = $(this).height() + 3;
      }
    });

    $('.collapse').on('hide.bs.collapse', function () {
      // do something…
      $(this).closest(".faq-q").find("i.toggle").addClass("fa-plus");
      $(this).closest(".faq-q").find("i.toggle").removeClass("fa-minus");
    });

    $('.collapse').on('show.bs.collapse', function () {
      // do something…
      $(this).closest(".faq-q").find("i.toggle").addClass("fa-minus");
      $(this).closest(".faq-q").find("i.toggle").removeClass("fa-plus");
    });

    const urlParams = new URL(window.location.href);


//            console.log();
    if(urlParams.searchParams.get('q')){
//                $().scrollIntoView();

//                location.assign("#"+urlParams.searchParams.get('q'));
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#"+urlParams.searchParams.get('q')).offset().top - 200
      }, 100);

      $("#"+urlParams.searchParams.get('q')).find(".collapse").addClass("show");
    }
    $('.slider-page .arrow-btn').on('click',function(){

      if($(this).prev().hasClass('active')){
        $(this).prev().removeClass('active');
        $(this).removeClass('active')
      }
      else{
        $('.slider-page p').removeClass('active');
        $('.slider-page .arrow-btn').removeClass('active');
        $(this).prev().addClass('active');
        $(this).addClass('active')
      }

    })
  });

  $('#menuToggle').click(function(){
    $('.overlay').toggleClass('active');
  })

// Selectric select
//   $(function() {
//     $('select').selectric({
//       // onBeforeInit: function(e) {
//       //     console.log(e);
//       // },
//       nativeOnMobile: false,
//       onInit: function(e) {
//         // console.log($(e).closest(".selectric-hide-select").find(".selectric"));
//         $(e).closest(".selectric-wrapper").find(".selectric .label").attr("data-selected_onclick", false);
//         $(e).closest(".selectric-wrapper").find(".selectric .label").addClass("no-label");
//
//         // $(e).closest(".selectric-wrapper").find(".selectric-items").width();
//       },
//
//     });
//     $('select').on('selectric-open', function(event, element, selectric) {
//       // your code
//       // console.log("class", $(element).closest(".selectric-wrapper"));
//       $(element).closest(".selectric-wrapper").find(".selectric").addClass("active-border");
//       $(element).closest(".selectric-wrapper").find(".selectric .button").addClass("invert-arrow");
//       $(element).closest(".selectric-wrapper").prev("label").addClass("move-back-up");
//       $(element).closest(".selectric-wrapper").prev("label").addClass("active-text-color");
//
//       // Subtract 1px width of the dropdown
//       // console.log("dropdown width", $(element).closest(".selectric-wrapper").find(".selectric-items").width());
//       // let dropdown_width = $(element).closest(".selectric-wrapper").find(".selectric-items").width() + 2;
//       // $(element).closest(".selectric-wrapper").find(".selectric-items").css({"width": dropdown_width});
//     });
//     $('select').on('selectric-close', function(event, element, selectric) {
//       // your code
//       $(element).closest(".selectric-wrapper").find(".selectric").removeClass("active-border");
//       $(element).closest(".selectric-wrapper").find(".selectric .button").removeClass("invert-arrow");
//       $(element).closest(".selectric-wrapper").prev("label").removeClass("active-text-color");
//       setTimeout(function(){
//         if($(element).closest(".selectric-wrapper").find(".selectric .label").attr("data-selected_onclick") === "false") {
//           $(element).closest(".selectric-wrapper").prev("label").removeClass("move-back-up");
//         }
//       }, 100);
//     });
//     $('select').on('selectric-select', function(event, element, selectric) {
//       // your code
//       // console.log("selectric", $(element).closest(".selectric-wrapper").find(".selectric .label").attr("data-selected_onclick"));
//       if($(element).closest(".selectric-wrapper").find(".selectric .label").attr("data-selected_onclick") === "false") {
//         $(element).closest(".selectric-wrapper").find(".selectric .label").attr("data-selected_onclick", true);
//         $(element).closest(".selectric-wrapper").find(".selectric .label").removeClass("no-label");
//       }
//     });
//
//   });

// $('select').on("selectric-change", function(element){
//     // console.log("ljbnferj", $(this));
//     var dropdowns_filled = false;
//     $(".mandatory-field").closest(".form-group .selectric").find(".label").each(function(elem) {
//         console.log("elem", elem);
//         if ($(elem).attr("data-selected_onclick") == "true") {
//             dropdowns_filled = true;
//         }
//     });
//     mandatoryDropdownCheck(dropdowns_filled);
// });

// function mandatoryDropdownCheck(empty_bool) {
//     console.log("dropdown empty", empty_bool);
//     return true;
// }
// Focus logic for normal text input
  $(".form-element--text .form-control, .form-element--text-portal .form-control, .form-element--textarea .form-control, .form-element--login-input .form-control").on("focus", function(){
    $(this).addClass("outline-zero");
    $(this).next("label").addClass("active-text-color");
    $(this).next("label").addClass("move-back-up");
  });
  $(".form-element--text .form-control, .form-element--text-portal .form-control, .form-element--textarea .form-control, .form-element--login-input .form-control").on("blur", function(){
    $(this).removeClass("outline-zero");
    $(this).next("label").removeClass("active-text-color");
    if(!$(this).val()) {
      $(this).next("label").removeClass("move-back-up");
    }
  });

// Mobile search
  $("#mobile_search").on("click", function(){
    $(this).closest(".nav-header").find(".search-block-mobile").addClass("slide-back");
  });
  $("#mobile-search-close").on("click", function(){
    $(this).closest(".search-block-mobile").removeClass("slide-back");
    $(this).closest(".search-block-mobile").find(".search-block-mobile__input").val("");
  });

// Partner us page watch for mandory fields to be filled and then remove the disabled attribute from button and vice versa

// $(".mandatory-field").closest(".form-group").find("input").keyup(function() {

//     var input_empty = false;
//     $(".mandatory-field").closest(".form-group").find("input").each(function() {
//         if ($(this).val() == '') {
//             input_empty = true;
//         }
//     });
//     var dropdown_empty = false;
//     $(".mandatory-field").closest(".form-group .selectric").find(".label").each(function() {
//         if ($(this).attr("data-selected_onclick") === "false") {
//             dropdown_empty = true;
//         }
//     });

//     if (input_empty && dropdown_empty) {
//         $('#partner_with_us_submit').attr('disabled', 'disabled'); // updated according to http://stackoverflow.com/questions/7637790/how-to-remove-disabled-attribute-with-jquery-ie
//     } else {
//         $('#partner_with_us_submit').removeAttr('disabled'); // updated according to http://stackoverflow.com/questions/7637790/how-to-remove-disabled-attribute-with-jquery-ie
//     }
// });
// $(".mandatory-field").closest(".form-group").find("input").keyup(function() {

//     var input_empty = false;
//     $(".mandatory-field").closest(".form-group").find("input").each(function() {
//         if ($(this).val() == '') {
//             input_empty = true;
//         }
//     });
//     var dropdown_empty = false;
//     $(".mandatory-field").closest(".form-group .selectric").find(".label").each(function() {
//         if ($(this).attr("data-selected_onclick") === "false") {
//             dropdown_empty = true;
//         }
//     });

//     if (input_empty && dropdown_empty) {
//         $('#partner_with_us_submit').attr('disabled', 'disabled'); // updated according to http://stackoverflow.com/questions/7637790/how-to-remove-disabled-attribute-with-jquery-ie
//     } else {
//         $('#partner_with_us_submit').removeAttr('disabled'); // updated according to http://stackoverflow.com/questions/7637790/how-to-remove-disabled-attribute-with-jquery-ie
//     }
// });

  $(document).ready(function(){
    // $('.partner-portal-carousel').owlCarousel({
    //   loop: true,
    //   margin: 10,
    //   nav: false,
    //   dots: true,
    //   items: 1,
    //   responsiveClass: true,
    //   responsive: {
    //     0:{
    //       items: 1,
    //       nav: false,
    //       dots: true,
    //       navText: ["", ""]
    //     }
    //   }
    // })
  });

// Portal search drop down logic
  $('#service_search_btn').on('shown.bs.dropdown', function () {
    // do something…
    var service_search_btn_ref = $(this);
    setTimeout(function(){
      console.log("cwe", $('#service_search_btn .dropdown-menu').attr("x-placement"));
      // $(this).closest(".input-group").find(".btn").addClass("br-bottom-left-zero");
      // $(this).closest(".input-group").find(".form-control").addClass("br-bottom-right-zero");
      if($('#service_search_btn .dropdown-menu').attr("x-placement") === "bottom-start") {
        service_search_btn_ref.closest(".service-search").addClass("service-search--x-placement-bottom-start");
      }
      if($('#service_search_btn .dropdown-menu').attr("x-placement") === "top-start") {
        service_search_btn_ref.closest(".service-search").addClass("service-search--x-placement-top-start");
      }
    }, 100);
    // portalDropdownXPlacement();
  })
  $('#service_search_btn').on('hidden.bs.dropdown', function () {
    // do something…
    // console.log("cwe");
    // $(this).closest(".input-group").find(".btn").removeClass("br-bottom-left-zero");
    // $(this).closest(".input-group").find(".form-control").removeClass("br-bottom-right-zero");
    if($(".service-search").hasClass("service-search--x-placement-bottom-start")) {
      // console.log("cwe");
      $(this).closest(".service-search").removeClass("service-search--x-placement-bottom-start");
    }
    if($(".service-search").hasClass("service-search--x-placement-top-start")) {
      $(this).closest(".service-search").removeClass("service-search--x-placement-top-start");
    }
  })

  $(window).on("scroll", function(){
    portalDropdownXPlacement();
  })

  function portalDropdownXPlacement() {
    if($('#service_search_btn').hasClass("show") && $('#service_search_btn .dropdown-menu').attr("x-placement") === "bottom-start") {
      $('#service_search_btn').closest(".service-search").addClass("service-search--x-placement-bottom-start");
      $('#service_search_btn').closest(".service-search").removeClass("service-search--x-placement-top-start");
    } else if($('#service_search_btn').hasClass("show") && $('#service_search_btn .dropdown-menu').attr("x-placement") === "top-start") {
      $('#service_search_btn').closest(".service-search").addClass("service-search--x-placement-top-start");
      $('#service_search_btn').closest(".service-search").removeClass("service-search--x-placement-bottom-start");
    } else {
      if($('#service_search_btn').hasClass("show")) {
        $('#service_search_btn').closest(".service-search").addClass("service-search--x-placement-bottom-start");
        $('#service_search_btn').closest(".service-search").removeClass("service-search--x-placement-top-start");
      }
    }
  }
  portalDropdownXPlacement();

}




// WEBPACK FOOTER //
// ./src/js/dito.js